import React, { useState } from "react";
import Mobile from "../components/Mobile";
import Header from "../components/Header";
import SideBar from "../components/SideBar";
import Index from "../components/Index";
import AllChristian from "../components/AllChristian";
import AddChristian from "../components/AddChristian";
import AddEvangelicalTeam from "../components/AddEvangelicalTeam";
import AllEvangelicalTeam from "../components/AllEvangelicalTeam";
import Announcement from "../components/Announcement";
import AddOffering from "../components/AddOffering";
import AddService from "../components/AddService";
import AllAttendance from "../components/AllAttendance";
import AllServices from "../components/AllServices";
import AllOfferings from "../components/AllOfferings";
import AddAttendance from "../components/AddAttendance";
import AllChildren from "../components/AllChildren";
import ViewReport from "../components/AllChristian";

function Home() {
  const [activeComponent, setActiveComponent] = useState("index"); // State to manage active component

  const handleMenuClick = (componentName) => {
    setActiveComponent(componentName);
  };

  return (
    <div className="py-5">
      <Mobile onMenuClick={handleMenuClick} />
      <Header />
      <div className="flex">
        <SideBar onMenuClick={handleMenuClick} />
        {activeComponent === "index" && <Index />}
        {activeComponent === "allChristian" && <AllChristian />}
        {activeComponent === "allChildren" && <AllChildren />}
        {activeComponent === "viewReport" && <ViewReport />}
        {activeComponent === "addChristian" && <AddChristian />}
       {/*  {activeComponent === "addEvangelicalTeam" && <AddEvangelicalTeam />}
        {activeComponent === "allEvangelicalTeam" && <AllEvangelicalTeam />}
        {activeComponent === "addAttendance" && <AddAttendance />}
        {activeComponent === "allOfferings" && <AllOfferings />}
        {activeComponent === "allServices" && <AllServices />}
        {activeComponent === "allAttendance" && <AllAttendance />}
        {activeComponent === "addService" && <AddService />}
        {activeComponent === "addOffering" && <AddOffering />}
        {activeComponent === "announcement" && <Announcement />} */}
      </div>
    </div>
  );
}

export default Home;
